/* Fransk katalog for locale-sales-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'adv.sales.productsShowMore': 'Afficher plus',
  'adv.sales.productsNote': 'Le montant sous « Chiffre d\'affaires le plus élevé » correspond aux ventes facturées par produit sur l\'année sélectionnée. Hausse et baisse indiquent la variation en pourcentage du chiffre d\'affaires du même produit par rapport à l\'année précédente. Les produits sans chiffres comparables de l\'année précédente ne figurent pas dans hausse et baisse.',
  'adv.sales.productsPage': 'Page {page} sur {pages}',
  'adv.sales.productsPrevious': 'Page précédente pour {label}',
  'adv.sales.productsNext': 'Page suivante pour {label}',
  'adv.sales.scn.adjust.priceUp': 'Hausse de prix',
  'adv.sales.scn.adjust.volumeDown': 'Baisse du volume des ventes',
  'sale.doc.invoice': 'Nouvelle facture',
  'sale.doc.quote': 'Nouveau devis',
  'sale.doc.orderConfirmation': 'Nouvelle confirmation de commande',
  'sale.doc.creditNote': 'Nouvel avoir',
  'sale.doc.other': 'Autre vente',
  'sale.howToCreate': 'Comment voulez-vous créer {document} ?',
  'sale.docIndefinite.invoice': 'une facture',
  'sale.docIndefinite.quote': 'un devis',
  'sale.docIndefinite.orderConfirmation': 'une confirmation de commande',
  'sale.docIndefinite.creditNote': 'un avoir',
  'sale.docIndefinite.other': 'une autre vente',
  'sale.credit.title': 'Avoir',
  'sale.credit.help': 'Un avoir annule une vente. Les montants sont saisis en positif comme sur une facture — Plumme inverse le signe lors de la comptabilisation, de sorte que le chiffre d\'affaires et la TVA collectée sont réduits et la créance client est créditée.',
  'sale.credit.reason': 'Motif de l\'avoir',
  'sale.credit.reasonHint': 'Obligatoire. La justification doit montrer ce qui s\'est réellement passé, pas seulement le montant.',
  'sale.credit.reasonPh': 'Retour de marchandise, remise de prix, erreur de facturation ...',
  'sale.credit.link': 'Rattacher à une facture',
  'sale.credit.linkHint': 'Facultatif. Si vous rattachez une facture, son numéro est repris automatiquement et l\'avoir est imputé sur le solde restant de la facture.',
  'sale.credit.linkNone': 'Aucun rattachement – avoir libre',
  'sale.credit.linkSearchPh': 'Rechercher par numéro de facture, client ou montant ...',
  'sale.credit.linkNoMatches': 'Aucune facture ne correspond à la recherche',
  'sale.credit.linkShowMore': 'Afficher plus de factures',
  'sale.credit.invoiceOption': 'Facture {number} · {customer}',
  'sale.credit.invoiceOptionMeta': '{date} · {amount}',
  'sale.credit.linkLocked': 'Sélectionnée depuis la facture',
  'sale.credit.noNumber': 'Sans numéro',
  'sale.credit.reference': 'Concerne (vente d\'origine)',
  'sale.credit.referenceHint': 'Obligatoire sans rattachement à une facture. Indiquez le numéro de facture, le contrat, la période ou le système dans lequel figurait la vente.',
  'sale.credit.referencePh': 'Par ex. facture 1042 ou « contrat 2025-04 »',
  'sale.credit.linkedTo': 'Avoir sur la facture {document}',
  'sale.credit.offsetBadge': 'Imputé automatiquement',
  'sale.credit.freeHint': 'Sans rattachement, le montant reste un avoir en faveur du client. Vous pouvez l\'imputer sur une facture ou le rembourser depuis la liste des factures.',
  'sale.credit.date': 'Date de l\'avoir',
  'sale.credit.numberLabel': 'N° d\'avoir :',
  'sale.credit.amount': 'Montant de l\'avoir',
  'sale.credit.previewNote': 'Le montant a été crédité. Il est imputé sur les sommes dues ou remboursé.',
  'sale.credit.previewReason': 'Motif :',
  'sale.credit.previewReference': 'Concerne :',
  'sale.credit.set': 'Renseigner les détails',
  'sale.credit.edit': 'Modifier',
  'sale.credit.missing': 'Le motif et la référence à la vente d\'origine doivent être renseignés avant de pouvoir créer l\'avoir.',
  'sale.credit.noReference': 'Aucune référence indiquée',
  'sale.credit.freeBadge': 'Avoir libre',
  'sale.credit.needReason': 'Indiquez d\'abord le motif de l\'avoir',
  'sale.credit.needReference': 'Rattachez une facture ou indiquez la vente d\'origine concernée par l\'avoir',
  'sale.credit.needDetails': 'Indiquez d\'abord un motif et rattachez une facture ou indiquez la vente d\'origine',
  'sale.credit.create': 'Créer l\'avoir',
  'sale.det.period': 'Période',
  'sale.det.subscriptionFrom': 'Abonnement du',
  'sale.det.subscriptionTo': 'Abonnement au',
  'sale.det.rentFrom': 'Location du',
  'sale.det.rentTo': 'Location au',
  'sale.lines.descShortPh': 'Par ex. heure de conseil ou abonnement',
  'sale.from': 'Du',
  'sale.to': 'Au',
  'sale.use': 'Utiliser',
  'sale.swap': 'Échanger',
  'sale.show': 'Afficher',
  'sale.edit': 'Modifier',
  'sale.download': 'Télécharger',
  'sale.send': 'Envoyer',
  'sale.add': 'Ajouter',
  'sale.save': 'Enregistrer',
  'sale.saveChanges': 'Enregistrer les modifications',
  'sale.thisSale': 'cette vente',
  'sale.step.kunde': 'Client',
  'sale.step.bilag': 'Justificatif',
  'sale.step.detaljer': 'Détails',
  'sale.step.linjer': 'Lignes',
  'sale.step.forhandsvisning': 'Aperçu',
  'sale.title': 'Vente / Facture / Devis',
  'sale.titleHelp': 'Enregistrez une vente, créez une facture, un devis ou une confirmation de commande',
  'sale.docTypeHelpTitle': 'Type de document',
  'sale.docTypeHelp': 'Choisissez le type de document de vente que vous créez. Une facture est une demande de paiement adressée au client. Un devis est une offre de prix sans engagement. Une confirmation de commande confirme une commande convenue. « Autre vente » sert aux ventes réalisées hors du système, pour lesquelles vous importez un justificatif.',
  'sale.stepsHelpTitle': 'Les étapes de la vente',
  'sale.stepsHelp': 'La vente comporte quatre étapes : Client, Détails, Lignes et Aperçu (pour « Autre vente » : Justificatif, Détails, Lignes et Aperçu). Appuyez sur une étape pour y accéder. Une étape est signalée s\'il manque quelque chose avant de pouvoir créer le document.',
  'sale.viewHelpTitle': 'Changer d\'affichage',
  'sale.viewHelpToOnePage': 'Passe du parcours par étapes à une page unique où tous les champs sont affichés en même temps, à côté d\'un aperçu en direct. Plus rapide une fois le formulaire maîtrisé.',
  'sale.viewHelpToSteps': 'Passe de la page unique à un parcours par étapes plus serein, où vous remplissez une chose à la fois — client, détails, lignes et aperçu. Idéal si vous souhaitez être guidé.',
  'sale.toOnePage': 'Passer à tout sur une page',
  'sale.toSteps': 'Passer au mode étape par étape',
  'sale.stepByStep': 'Étape par étape',
  'sale.previewHelpTitle': 'Aperçu',
  'sale.previewHelp': 'Voici comment le document final apparaîtra au client — avec l\'expéditeur, les informations client, les lignes et le total. Il se met à jour pendant la saisie, pour que vous puissiez tout vérifier avant de créer ou d\'envoyer.',
  'sale.previewToggleHelp': 'Affiche ou masque l\'aperçu en direct à côté du formulaire. Masquez-le si vous voulez plus d\'espace pour les champs.',
  'sale.previewHide': 'Masquer l\'aperçu',
  'sale.previewShow': 'Afficher l\'aperçu',
  'sale.previewHeading': 'Aperçu du document',
  'sale.backToVouchers': 'Retour aux transactions',
  'sale.resetTitle': 'Réinitialiser le formulaire et recommencer',
  'sale.reset': 'Réinitialiser',
  'sale.resetDone': 'Le formulaire a été réinitialisé',
  'sale.back': 'Retour',
  'sale.next': 'Suivant',
  'sale.draftSaved': 'Brouillon enregistré',
  'sale.draftSavedHelp': 'Le brouillon figure dans la liste des factures tel qu\'il est actuellement. Si vous modifiez quelque chose, vous pouvez enregistrer à nouveau — cela met à jour le même brouillon.',
  'sale.saveDraft': 'Enregistrer le brouillon',
  'sale.saveDraftHelpTitle': 'Enregistrer le brouillon',
  'sale.saveDraftHelp': 'Enregistre la vente comme brouillon dans la liste des factures sans l\'envoyer ni la créer. Vous pourrez reprendre là où vous vous étiez arrêté.',
  'sale.saveDraftHelpLong': 'Enregistre la vente comme brouillon dans la liste des factures sans l\'envoyer ni la créer. Vous pouvez quitter la page en toute sécurité et reprendre plus tard là où vous vous étiez arrêté.',
  'sale.saveDraftHelpShort': 'Enregistre la vente comme brouillon dans la liste des factures sans l\'envoyer ni la créer. Vous pouvez quitter la page en toute sécurité et reprendre plus tard.',
  'sale.drafts': 'Brouillons',
  'sale.draftsTitle': 'Ventes commencées que vous n\'avez pas encore créées',
  'sale.noDrafts': 'Aucun brouillon',
  'sale.searchDrafts': 'Rechercher dans les brouillons...',
  'sale.deleteDraft': 'Supprimer le brouillon',
  'sale.deleteDraftTitle': 'Supprimer le brouillon ?',
  'sale.deleteDraftBody': 'Voulez-vous vraiment supprimer le brouillon pour {customer} ? Cette action est irréversible.',
  'sale.det.help': 'Dates, références et commentaire du document. La date de facture et la date d\'échéance déterminent quand la créance s\'applique et arrive à échéance. « Notre référence » est la personne en charge chez vous, « Votre référence » est le projet ou l\'interlocuteur du client. Pour les factures, vous pouvez aussi activer la récurrence afin qu\'elle soit envoyée automatiquement à chaque période.',
  'sale.det.date': 'Date',
  'sale.det.due': 'Échéance',
  'sale.det.ourRef': 'Notre référence',
  'sale.det.ourRefPh': 'Ex. la personne en charge chez nous',
  'sale.det.theirRef': 'Votre référence',
  'sale.det.theirRefPh': 'Votre référence / projet',
  'sale.det.payTo': 'Payer à',
  'sale.det.payToHelp': 'Le compte bancaire sur lequel le client doit payer la facture. La liste affiche vos comptes bancaires enregistrés — le compte de facturation des paramètres est présélectionné, et vous pouvez ajouter un nouveau compte directement ici.',
  'sale.det.payToDefault': 'Compte de facturation',
  'sale.det.payToEmpty': 'Aucun compte bancaire enregistré',
  'sale.det.payToAdd': '+ Ajouter un compte bancaire ...',
  'sale.det.comment': 'Commentaire',
  'sale.det.commentPh': 'Commentaire facultatif affiché sur le document',
  'sale.det.savedComments': 'Commentaires enregistrés',
  'sale.det.saveComment': 'Enregistrer le commentaire',
  'sale.det.useComment': 'Utiliser le commentaire',
  'sale.det.noSavedComments': 'Aucun commentaire enregistré pour l\'instant.',
  'sale.det.deliveryFrom': 'Période de livraison/d\'exécution - Du',
  'sale.det.deliveryTo': 'Période de livraison/d\'exécution - Au',
  'sale.det.repeating': 'Récurrente',
  'sale.det.repeatingHelpTitle': 'Facture récurrente',
  'sale.det.repeatingHelp': 'Activez cette option pour que la facture soit envoyée automatiquement à intervalles réguliers — par exemple chaque mois pour un abonnement. Vous choisissez l\'intervalle et l\'échéance, et Plumme crée et envoie une nouvelle facture à chaque période sans que vous ayez rien à faire.',
  'sale.det.sentEvery': 'Envoyée chaque',
  'sale.period.week': 'Semaine',
  'sale.period.month': 'Mois',
  'sale.period.quarter': 'Trimestre',
  'sale.period.year': 'Annuel',
  'sale.det.sameDay': 'Le jour même',
  'sale.lines.help': 'Les biens et services de la vente. Chaque ligne comporte une quantité, un prix, un taux de TVA et une éventuelle remise, et le total de ligne est calculé automatiquement. Choisissez un produit enregistré ou saisissez du texte libre, et faites glisser la poignée à gauche pour changer l\'ordre.',
  'sale.lines.add': 'Ajouter une ligne',
  'sale.lines.product': 'Produit',
  'sale.lines.productPh': 'Rechercher ou saisir un nouveau produit...',
  'sale.lines.noProductMatch': 'Aucun produit enregistré ne correspond',
  'sale.lines.editProduct': 'Modifier le produit',
  'sale.lines.productName': 'Nom du produit',
  'sale.lines.description': 'Description',
  'sale.lines.descriptionPh': 'Description facultative du produit/de la ligne',
  'sale.lines.qty': 'Quantité',
  'sale.lines.vat': 'TVA',
  'sale.lines.discount': 'Remise',
  'sale.lines.netSum': 'Total de ligne HT',
  'sale.lines.toggleVat': 'Basculer entre HT et TTC',
  'sale.lines.more': 'Plus',
  'sale.lines.less': 'Moins',
  'sale.lines.searchAccount': 'Rechercher un compte...',
  'sale.lines.noAccountMatch': 'Aucun compte ne correspond à la recherche.',
  'sale.lines.pickAccount': 'Choisir un compte',
  'sale.lines.searchProductPh': 'Rechercher par nom ou description...',
  'sale.sum.help': 'Le total de toute la vente : le montant HT plus la TVA donne le montant que le client doit payer. Les chiffres se mettent à jour automatiquement lorsque vous modifiez les lignes.',
  'sale.att.title': 'Pièces jointes',
  'sale.att.upload': 'Téléverser une pièce jointe',
  'sale.att.drop': 'Faites glisser des fichiers ici',
  'sale.att.dropHint': 'Images ou PDF, ou collez',
  'sale.att.pickFile': 'Choisir un fichier',
  'sale.att.dropToAdd': 'Déposez la pièce jointe pour l\'ajouter',
  'sale.att.dragTip': 'Astuce : vous pouvez aussi faire glisser des fichiers directement sur la page.',
  'sale.att.forgot': 'Vous avez oublié un justificatif ? Déposez-le ici',
  'sale.att.fromInbox': 'Récupérer depuis la boîte de réception',
  'sale.att.uploadInstead': 'Téléverser plutôt un justificatif',
  'sale.att.view': 'Voir le justificatif',
  'sale.att.openPreview': 'Ouvrir dans l\'aperçu',
  'sale.send.title': 'Envoi du document',
  'sale.send.to': 'Envoyer à',
  'sale.send.replyTo': 'Répondre à',
  'sale.send.asPdf': 'Envoyer en pièce jointe PDF',
  'sale.send.asLink': 'Envoyer sous forme de lien',
  'sale.send.pdfHint': 'Le client reçoit le document directement dans l\'e-mail.',
  'sale.send.linkHint': 'Indique le statut de lecture lorsque le client ouvre le document.',
  'sale.send.how': 'Comment le document doit-il être envoyé ?',
  'sale.send.newRecipient': 'Nouvelle adresse e-mail …',
  'sale.send.saveContact': 'Enregistrer comme contact de {customer}',
  'sale.send.thisCustomer': 'le client',
  'sale.send.contactName': 'Nom',
  'sale.send.contactNamePh': 'Jean Dupont',
  'sale.send.contactRole': 'Rôle',
  'sale.send.contactRolePh': 'Comptabilité',
  'sale.send.contactSaveFailed': 'Le document a été envoyé, mais le contact n\'a pas pu être enregistré.',
  'sale.send.emailPh': 'name@example.com',
  'sale.send.viewDocument': 'Voir le document',
  'sale.preview.sender': 'Expéditeur :',
  'sale.preview.invoiceNo': 'N° de facture :',
  'sale.preview.invoiceDate': 'Date de facture :',
  'sale.preview.dueDate': 'Date d\'échéance :',
  'sale.preview.ourRef': 'Notre référence :',
  'sale.preview.theirRef': 'Votre référence :',
  'sale.preview.comment': 'Commentaire :',
  'sale.preview.accountNo': 'N° de compte :',
  'sale.preview.toPay': 'À payer :',
  'sale.preview.net': 'Net',
  'sale.preview.vat': 'TVA',
  'sale.preview.paid': 'Payé',
  'sale.preview.toPayShort': 'À payer',
  'sale.preview.receipt': 'Reçu',
  'sale.preview.paymentHint': 'Merci d\'indiquer le numéro de facture lors du paiement',
  'sale.preview.currencyNote': 'Tous les montants sont exprimés en {currency}',
  'sale.lines.fromDraftDescr': 'Repris du brouillon',
  'sale.att.maxSize': 'Les pièces jointes ne peuvent pas dépasser {max}.',
  'sale.att.addedOne': '1 pièce jointe ajoutée',
  'sale.att.addedMany': '{count} pièces jointes ajoutées',
  'sale.comment.deleted': 'Commentaire supprimé',
  'sale.comment.deleteFailed': 'Impossible de supprimer le commentaire.',
  'sale.comment.writeFirst': 'Écrivez d\'abord un commentaire',
  'sale.comment.updated': 'Commentaire mis à jour',
  'sale.comment.saveFailed': 'Impossible d\'enregistrer le commentaire.',
  'sale.comment.alreadySaved': 'Le commentaire est déjà enregistré',
  'sale.comment.saved': 'Commentaire enregistré',
  'sale.comment.backendUnavailable': 'Les commentaires ne sont pas connectés au backend.',
  'sale.det.offerDate': 'Date du devis',
  'sale.det.orderDate': 'Date de commande',
  'sale.det.saleDate': 'Date de vente',
  'sale.det.invoiceDateLabel': 'Date de facture',
  'sale.det.validUntil': 'Valable jusqu\'au',
  'sale.det.dueDateLabel': 'Date d\'échéance',
  'sale.textLine.titleUpdate': 'Mettre à jour la ligne de texte',
  'sale.textLine.titleNewHeading': 'Nouveau titre',
  'sale.textLine.titleNewText': 'Nouvelle ligne de texte',
  'sale.textLine.update': 'Mettre à jour',
  'sale.textLine.typeLabel': 'Type',
  'sale.textLine.typeText': 'Ligne de texte',
  'sale.textLine.typeHeading': 'Titre',
  'sale.textLine.nameLabel': 'Nom',
  'sale.textLine.namePhHeading': 'Ex. Travaux',
  'sale.textLine.namePhText': 'Ex. Produit X',
  'sale.textLine.textLabel': 'Texte',
  'sale.textLine.textPh': 'Texte facultatif affiché sous la ligne',
  'sale.textLine.styleFor': 'Style pour {target}',
  'sale.textLine.boldShort': 'G',
  'sale.textLine.italicShort': 'I',
  'sale.textLine.useDivider': 'Utiliser une ligne de séparation',
  'sale.textLine.dividerHint': 'Afficher une ligne sous le texte dans le document.',
  'sale.textLine.searchPhHeading': 'Rechercher ou saisir un titre...',
  'sale.textLine.searchPhText': 'Rechercher ou saisir une ligne de texte...',
  'sale.textLine.noMatch': 'Aucune ligne de texte enregistrée ne correspond',
  'sale.textLine.addAsHeading': 'Ajouter « {value} » comme nouveau titre',
  'sale.textLine.addAsText': 'Ajouter « {value} » comme nouvelle ligne de texte',
  'sale.textLine.headingSaved': 'Titre enregistré',
  'sale.textLine.textSaved': 'Ligne de texte enregistrée',
  'sale.textLine.headingAdded': 'Titre ajouté',
  'sale.textLine.textAdded': 'Ligne de texte ajoutée',
  'sale.textLine.saveFailed': 'Impossible d\'enregistrer la ligne de texte.',
  'sale.det.durationMonth1': '1 mois',
  'sale.det.durationMonth3': '3 mois',
  'sale.det.durationMonth6': '6 mois',
  'sale.det.durationMonth12': '12 mois',
  'sale.lines.typeProduct': 'Ligne de produit',
  'sale.lines.typeSpacer': 'Espace',
  'sale.lines.noText': 'Sans texte',
  'sale.lines.qtyUnit': '{qty} pcs',
  'sale.preview.receiptNoLabel': 'N° de reçu :',
  'sale.preview.quoteNoLabel': 'N° de devis :',
  'sale.preview.orderNoLabel': 'N° de commande :',
  'sale.preview.backToOther': 'Retour à Autre vente',
  'sale.preview.backToInvoice': 'Retour à la facture',
  'sale.preview.vatMoms': 'TVA',
  'sale.preview.continuesNextPage': 'Suite à la page suivante',
  'sale.att.labelWithName': 'Pièce jointe · {name}',
  'sale.att.dropHere': 'Déposez le justificatif ici',
  'sale.att.otherSaleHint': 'Autre vente concerne les ventes générales hors du système - téléversez une image ou un PDF comme justificatif.',
  'sale.att.previewHint': 'Pour l\'aperçu, appuyez sur l\'une de vos pièces jointes ou sur « Voir le reçu ».',
  'sale.att.viewReceipt': 'Voir le reçu',
  'sale.att.createReceipt': 'Créer un reçu',
  'sale.mode.subtitle': 'Choisissez un parcours étape par étape ou gardez tous les champs sur une seule page.',
  'sale.mode.stepsDesc': 'Client, détails, lignes et aperçu - une chose à la fois. Idéal pour débuter.',
  'sale.mode.onePageDesc': 'Toute la facture d\'un coup d\'œil avec un aperçu en direct. Rapide pour les habitués.',
  'sale.draft.noCustomer': 'Sans client',
  'sale.draft.noMatchesTitle': 'Aucun résultat',
  'sale.draft.noMatchesText': 'Aucun brouillon ne correspond à la recherche.',
  'sale.draft.emptyText': 'Les ventes commencées sont enregistrées ici lorsque vous appuyez sur « Enregistrer le brouillon ».',
  'sale.draft.colSale': 'Vente',
  'sale.draft.noNumber': 'Sans numéro',
  'sale.draft.colDate': 'Date',
  'sale.draft.colAmount': 'Montant',
  'sale.draft.deleteFailed': 'Impossible de supprimer le brouillon.',
  'sale.draft.saveFailed': 'Impossible d\'enregistrer le brouillon.',
  'sale.draft.deleteUnavailable': 'La suppression des brouillons n\'est pas connectée au backend.',
  'sale.draft.onlyDraftsDelete': 'Seuls les brouillons peuvent être supprimés ici',
  'sale.draft.deleted': 'Brouillon supprimé',
  'sale.draft.saveUnavailable': 'L\'enregistrement des brouillons n\'est pas connecté au backend.',
  'sale.draft.savedToList': 'Le brouillon a été enregistré dans la liste des factures',
  'sale.create.invoice': 'Créer la facture',
  'sale.create.quote': 'Créer le devis',
  'sale.create.order': 'Créer la confirmation de commande',
  'sale.create.other': 'Enregistrer la vente',
  'sale.create.needMatchingPartials': 'La somme des paiements partiels doit d\'abord correspondre au total de la vente',
  'sale.create.needLineOrAttachment': 'Ajoutez d\'abord une ligne ou un justificatif',
  'sale.create.needCustomerAndProduct': 'Choisissez d\'abord un client et ajoutez au moins un produit',
  'sale.create.needCustomer': 'Choisissez d\'abord un client',
  'sale.create.needProduct': 'Ajoutez d\'abord au moins un produit',
  'sale.create.receiptSendingBackground': 'Le reçu est envoyé en arrière-plan',
  'sale.create.receiptSentEmail': 'Le reçu a été envoyé par e-mail.',
  'sale.create.recurringSaveFailed': 'La facture a été créée, mais le contrat récurrent n\'a pas pu être enregistré.',
  'sale.create.createFailed': 'Impossible de créer la vente.',
  'sale.create.createdTitle': '{doc} {num} a été créé(e).',
  'sale.create.saleCreatedBody': 'La vente a été comptabilisée. Vous pouvez enregistrer le reçu, envoyer la documentation au client ou fermer.',
  'sale.create.docCreatedBody': 'Vous pouvez enregistrer {def} en PDF ou {pron} transmettre par e-mail.',
  'sale.create.pdfReceiptLabel': 'PDF/Reçu',
  'sale.create.pdfLabel': 'PDF',
  'sale.send.unavailableSale': 'L\'envoi n\'est pas disponible pour cette vente.',
  'sale.send.unavailableDocument': 'L\'envoi n\'est pas disponible pour ce document.',
  'sale.send.failed': 'L\'envoi a échoué.',
  'sale.send.customerFallback': 'Client',
  'sale.send.defaultContactRole': 'Contact par défaut',
  'sale.send.contactFallback': 'Personne de contact',
  'sale.send.recipientFallback': 'Destinataire',
  'sale.send.receiptTitle': 'Envoyer le reçu',
  'sale.send.howToSend': 'Comment voulez-vous envoyer {doc} ?',
  'sale.send.receiptEmailHint': 'Saisissez l\'adresse e-mail à laquelle le reçu doit être envoyé.',
  'sale.send.chooseDeliveryHint': 'Choisissez si le client reçoit un PDF dans l\'e-mail, ou un lien que Postplumma peut suivre.',
  'sale.send.allCustomersInList': 'Tous les clients de la liste ({count})',
  'sale.send.needEmailFirst': 'Saisissez un e-mail pour le client ou une personne de contact avant l\'envoi.',
  'sale.send.stepDraftPrep': 'Préparation du brouillon',
  'sale.send.stepArriving': 'Postplumma arrive',
  'sale.send.stepSuccess': 'Succès ! Postplumma est en route.',
  'sale.send.receiptReadyNoEmail': 'Le reçu est prêt, mais aucun e-mail n\'a été envoyé.',
  'sale.send.sendingInBackground': '{doc} est envoyé(e) en arrière-plan',
  'sale.send.sentAsLinkShort': '{doc} a été envoyé(e) sous forme de lien.',
  'sale.send.sentAsLinkTracked': '{doc} a été envoyé(e) sous forme de lien. Vous pouvez suivre le statut de lecture dans la liste des factures.',
  'sale.send.sentAsEmail': '{doc} a été envoyé(e) par e-mail.',
  'sale.send.readyNoEmail': '{doc} est prêt(e), mais aucun e-mail n\'a été envoyé.',
  'sale.send.sentToRecipients': 'Envoyé à {count} destinataires.',
  'sale.send.notProvided': 'Non renseigné',
  'sale.send.spamTip': 'Astuce : si le client ne trouve pas l\'e-mail, demandez-lui de vérifier ses courriers indésirables.',
  'sale.inboxPicker.tabInbox': 'Boîte de réception ({count})',
  'sale.inboxPicker.tabDocumentation': 'Documentation ({count})',
  'sale.inboxPicker.searchDocumentation': 'Rechercher dans la documentation',
  'sale.inboxPicker.searchInbox': 'Rechercher dans la boîte de réception',
  'sale.inboxPicker.selectTip': 'Astuce : maintenez Shift pour sélectionner plusieurs éléments consécutifs, ou Ctrl/Cmd pour les sélectionner un par un.',
  'sale.inboxPicker.emptyDocumentation': 'Aucun document ne correspond à la recherche.',
  'sale.inboxPicker.emptyInbox': 'Aucun justificatif de la boîte de réception ne correspond à la recherche.',
  'sale.inboxPicker.fallbackReceipt': 'Justificatif',
  'sale.inboxPicker.fallbackDocument': 'Document',
  'sale.inboxPicker.fallbackDocumentation': 'Documentation',
  'sale.lines.subscriptionPeriod': 'Abonnement - {{period}}',
  'sale.lines.months12': '12 mois',
  'sale.lines.month1': '1 mois',
  'sale.lines.rentalPrice': 'Location - {{price}}',
  'sale.lines.addAsNewProduct': 'Ajouter « {{value}} » comme nouveau produit',
  'sale.lines.useDivider': 'Utiliser une ligne de séparation',
  'sale.lines.dividerHint': 'Affiche une ligne sous cette rangée dans le document.',
  'sale.preview.colDescription': 'Description',
  'sale.preview.colQty': 'Qté',
  'sale.preview.colPrice': 'Prix',
  'sale.preview.colDiscount': 'Remise',
  'sale.preview.colSum': 'Total',
  'sale.doc.invoiceName': 'Facture',
  'sale.doc.quoteName': 'Devis',
  'sale.doc.orderConfirmationName': 'Confirmation de commande',
  'sale.doc.creditNoteName': 'Avoir',
  'sale.draft.colType': 'Type',
  'sale.period.every14days': 'Tous les 14 jours',
  'sale.det.dueDays': '{{count}} jours',
  'sale.lines.priceExVat': 'Prix HT',
  'sale.lines.priceIncVat': 'Prix TTC',
  'sale.lines.lineNumber': 'Ligne {{n}}',
  'sale.lines.pickProduct': 'Choisir un produit',
  'sale.lines.freeText': 'Texte libre',
  'sale.lines.spacerHint': 'Une ligne vide apparaît comme un espace dans le document.',
  'sale.lines.chooseLineType': 'Choisir le type de ligne',
  'agreements.notSent': 'Non envoyé',
  'agreements.error.missingCustomerEmail': 'Le client n\'a pas d\'adresse e-mail. Ajoutez un e-mail au client et la facture sera envoyée lors du prochain traitement.',
  'agreements.error.missingCustomer': 'Le client n\'existe plus ou est archivé. Choisissez un client actif pour le contrat.',
  'agreements.warning.missingCustomerEmail': 'Le client n\'a pas d\'adresse e-mail',
  'agreements.warning.missingCustomerEmailHelp': 'L\'envoi automatique nécessite une adresse e-mail. Ajoutez-la au client avant la prochaine date de facturation, sinon la facture ne sera pas envoyée.',
});
